import React from "react"

import { Checkbox } from "react-icheck"
import { css } from "emotion"
import { withTheme } from "emotion-theming"
import "icheck/skins/all.css" // or single skin css

class StackerCheckbox extends React.Component {
    render() {
        let style = css`
            margin: 0px ${this.props.theme[this.props.margin || "small"]};
        `

        return (
            <React.Fragment>
                <Checkbox {...this.props}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    checked={this.props.value}
                    onChange={(e, checked) => this.props.onChange && this.props.onChange(checked)}
                    label=" "
                    style={style}
                />
            </React.Fragment>
        )
    }
}
export default withTheme(StackerCheckbox)



// WEBPACK FOOTER //
// ./src/ui/components/Checkbox.js